// ---------------------------------------------------------------------------
// 元に戻す／やり直す の控え（#140、docs/47 §15・docs/10 §5.4）。見積書（PC）の画面の 行と内訳 の状態を、変える前に1手ずつ控える。
//   ・max 手まで（古いものから捨てる）
//   ・同じ key（同じ行の同じ欄を打ち続けている）のあいだは1手にまとめる。行を開く・閉じる・移る・元に戻すで切る（breakTyping）
//   ・いまと同じ形の控え（足しただけの空の行を落とした など）は1手に数えない（元に戻すで何も起きない手を作らない）
//   ・新しく変えたら「やり直す」は捨てる
//   画面の部品を持たない純粋なもの（Vitest で 50 手・まとめ・飛ばしを確かめる）
// ---------------------------------------------------------------------------

export class UndoStack<T> {
  past: T[] = [];
  future: T[] = [];
  private key: string | null = null;
  constructor(
    private readonly same: (a: T, b: T) => boolean,
    readonly max = 50,
  ) {}

  get canUndo(): boolean {
    return this.past.length > 0;
  }
  get canRedo(): boolean {
    return this.future.length > 0;
  }

  /** 変える前の形（now）を控える。key が前と同じなら控えない（打ち続け）。控えたら true */
  record(now: T, key: string | null = null): boolean {
    if (key && this.key === key) return false;
    this.key = key;
    const top = this.past[this.past.length - 1];
    if (top !== undefined && this.same(top, now)) return false;
    this.past.push(now);
    if (this.past.length > this.max) this.past.shift();
    this.future = [];
    return true;
  }
  /** 打ち続けのまとまりを切る */
  breakTyping(): void {
    this.key = null;
  }
  /** 履歴を切る（サーバーで起きたことのあと） */
  clear(): void {
    this.past = [];
    this.future = [];
    this.key = null;
  }
  /** いまと同じ形の控えを上から捨てる。捨てた数 */
  dropSame(now: T): number {
    let n = 0;
    while (this.past.length && this.same(this.past[this.past.length - 1]!, now)) {
      this.past.pop();
      n++;
    }
    return n;
  }
  /** 1手戻す：戻る先の形（無ければ undefined）。いまの形は「やり直す」へ */
  undo(now: T): T | undefined {
    this.key = null;
    let to = this.past.pop();
    while (to !== undefined && this.same(to, now)) to = this.past.pop();
    if (to === undefined) return undefined;
    this.future.push(now);
    return to;
  }
  /** やり直す：進む先の形（無ければ undefined）。いまの形は「元に戻す」へ */
  redo(now: T): T | undefined {
    this.key = null;
    const to = this.future.pop();
    if (to === undefined) return undefined;
    this.past.push(now);
    return to;
  }
}
